<template>
  <div class="export-page">
    <v-row>
      <v-col cols="12" lg="6">
        <ExternalSystemsSection :wwwroot="$model.wwwroot" />
      </v-col>
      <v-col cols="12" lg="6">
        <RegistersSection :wwwroot="$model.wwwroot" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ExternalSystemsSection from './sections/ExternalSystemsSection.vue';
import RegistersSection from './sections/RegistersSection.vue';

export default {
  name: 'ExportPage',
  components: {
    ExternalSystemsSection,
    RegistersSection,
  },
};
</script>

<style scoped>
.export-page {
  width: 100%;
}
</style>
